/* global wc_cart_params */
/* global store_credit_params */

export default {
  init() {
    initializeMaintenanceProductsModal();
  },
  finalize() {
    coupon_ajax();
    show_coupon_button();
    updateCart();

    $(document.body).on('updated_cart_totals', function() {
      initializeMaintenanceProductsModal();
    });
  },
};

export var initializeMaintenanceProductsModal = () => {
  let maintenanceProductsModal = $('.maintenance-products-modal').wsModal();

  $(document).off('click', '.show-maintenance').on('click', '.show-maintenance', function () {
    maintenanceProductsModal.wsModal('open');
    $('.maintenance-products h2 .product-name').text($(this).attr('data-product'));
    $('.maintenance-products-content').empty();
    $('.maintenance-products-content').append($(this).closest('.wolky-cart-item').find('.product-maintenance-products').html());
  });
};

export var coupon_ajax = () => {
  $(document).on('click', '#coupon_code_button', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    let coupon_code = $('#coupon_code').val();
    apply_coupon(coupon_code);
  });
};

export var show_coupon_button = () => {
  $(document).on('focus', '#coupon_code', function () {
    $(document).on('keypress', '#coupon_code', function (e) {
      if (e.which === 13) {
        e.preventDefault();
        e.stopImmediatePropagation();
        let coupon_code = $('#coupon_code').val();
        apply_coupon(coupon_code);
      }
    });
  });

  $(document).on('click', '.coupon_form .coupon_form_toggle', function () {
    $(this).parent().toggleClass('open');
  });
};

export var apply_coupon = (coupon_code) => {
  let scrollPosition = $(window).scrollTop();
  window.isApplyingCoupon = true; // Set flag

  $.ajax({
    type: 'POST',
    url: store_credit_params.wc_ajax_url.replace('%%endpoint%%', 'ws_apply_coupon'),
    data: {
      'coupon_code': coupon_code,
      'security': wc_cart_params.apply_coupon_nonce,
    },
  })
    .done(function(response) {
      if (response.data !== true) {
        console.log('Invalid coupon:', response);
      }
      $(document.body).trigger('wc_update_cart');

      $(document.body).one('updated_cart_totals', function() {
        setTimeout(function() {
          $(window).scrollTop(scrollPosition);
          window.isApplyingCoupon = false; // Reset flag
        }, 500);
      });
    })
    .fail(function() {
      $(document.body).trigger('wc_update_cart');
      window.isApplyingCoupon = false; // Reset flag
    });
};

// --- Better notice handling ---
$(document).ready(function() {
    // 1. Block automatic scrolling when applying a coupon
    if (typeof $.scroll_to_notices !== 'undefined') {
        let originalScrollToNotices = $.scroll_to_notices;
        $.scroll_to_notices = function() {
            if (window.isApplyingCoupon) {
                console.log('WooCommerce scroll blocked for coupon');
                return;
            }
            originalScrollToNotices.apply(this, arguments);
        };
    }

    // 2. Selectively remove "removed" notices that have an "Undo" link
    if (typeof window.MutationObserver !== 'undefined') {
        const observer = new window.MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1 && (node.classList.contains('woocommerce-message') || node.classList.contains('woocommerce-info'))) {
                        let $notice = $(node);
                        let text = $notice.text();
                        // Check if contains "verwijderd" or "removed" AND "Undo" or "Ongedaan maken"
                        if ((text.includes('verwijderd') || text.includes('removed')) && 
                            (text.includes('Undo') || text.includes('Ongedaan maken'))) {
                            $notice.remove();
                        }
                    }
                });
            });
        });

        const targetNode = document.querySelector('.woocommerce-notices-wrapper');
        if (targetNode) {
            observer.observe(targetNode, { childList: true, subtree: true });
        }
    }
});

export var updateCart = () => {
  // Handle remove button click
  $(document).on('click', '.product-remove a', function(e) {
    e.preventDefault();
    const removeUrl = $(this).attr('href');
    $(this).closest('.wolky-cart-item').addClass('processing');
    window.location.href = removeUrl;
  });

  $(document).on('click', '.quantity-input-price .plus, .quantity-input-price .minus', function () {
    const $inputField = $(this).closest('.quantity-input-price').find('input.qty');
    const currentValue = parseInt($inputField.val()) || 1;
    const step = parseInt($inputField.attr('step')) || 1;

    let min = parseInt($inputField.attr('min')) || 1;
    if (min < 1) min = 1;

    const max = parseInt($inputField.attr('max')) || 9999;
    let newValue;

    if ($(this).hasClass('plus')) {
      newValue = currentValue + step;
      if (newValue > max) newValue = max;
    } else {
      newValue = currentValue - step;
      if (newValue < min) newValue = min;
    }

    if (newValue !== currentValue) {
      $inputField.val(newValue).trigger('input');
    }
  });

  $(document).on('input', '.quantity-input-price input.qty', function () {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    const $inputField = $(this);
    const $productQuantityBlock = $inputField.closest('.product-quantity');

    let new_qty = parseInt($inputField.val());
    if (new_qty < 1 || isNaN(new_qty)) {
      new_qty = 1;
      $inputField.val(new_qty);
    }

    this.debounceTimer = setTimeout(() => {
      const cart_item_key_match = $inputField.attr('name').match(/cart\[(\w+)\]/);
      if (!cart_item_key_match) return;

      const cart_item_key = cart_item_key_match[1];
      const nonce = $productQuantityBlock.data('nonce');

      $inputField.closest('.wolky-cart-item').addClass('processing');

      $.ajax({
        type: 'POST',
        url: store_credit_params.wc_ajax_url.replace('%%endpoint%%', 'wolky_update_cart_item_quantity'),
        data: {
          cart_item_key: cart_item_key,
          new_qty: new_qty,
          security: nonce,
        },
        success: function (response) {
          if (response.success) {
            if (response.data.cart_is_empty) {
              window.location.reload();
            } else {
              $(document.body).trigger('wc_update_cart');
            }
          } else {
            console.error('Failed to update cart:', response.data.message);
            $inputField.closest('.wolky-cart-item').removeClass('processing');
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.error('AJAX Error:', textStatus, errorThrown);
          $inputField.closest('.wolky-cart-item').removeClass('processing');
        },
      });
    }, 1000);
  });
};
